import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

const PhotoNoSearchResults = ({ clearFilters }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_PHOTO_GREY}
      title={T.translate('NO_PHOTOS')}
      description={T.translate('NO_PHOTOS_DESCRIPTION')}
    >
      <LinkButton onClick={clearFilters}>
        {T.translate('CLEAR_SEARCH')}
      </LinkButton>
    </EmptyState>
  );
};

PhotoNoSearchResults.propTypes = {
  clearFilters: PropTypes.func,
};

export default PhotoNoSearchResults;
